import { BaseEntityModel } from '@/modules/core/app/models/abstracts/BaseEntityModel';
import { ModelType } from '@/modules/core/app/constants/ModelType';

export class TypeformThreshold extends BaseEntityModel {
  id?: string;
  value?: number;
  label?: string;
  color?: string;
  typeformFormId?: string;

  constructor(model: Partial<TypeformThreshold> = {}) {
    super(model);

    this.id = model.id;
    this.value = model.value;
    this.label = model.label;
    this.color = model.color;
    this.typeformFormId = model.typeformFormId;
  }

  getModelName(): ModelType {
    return ModelType.TYPEFORM_THRESHOLD;
  }
}
